<template>
  <page title="Billing Report" :loading="loading">
    <template #body>
      <div class="form">
        <div class="input-group size-md">
          <dropdown
            label="Account"
            v-model="account"
            :list="accountList"
            :loading="searchAccountLoading"
            @search="searchAccount"
            @listClosed="accountList = []"
            @select="getBills"
            :options="{ searchMode: 'customOnType' }"
          />
        </div>

        <div v-if="current !== null" class="input-group result">
          <div class="section">
            <div class="title-container">
              <div class="title">Bills</div>
              <div class="title total">
                Total devices: {{current.rates.bills.reduce((acc, curr) => acc + curr.totals.count.count, 0)}}
              </div>
            </div>
            <data-table :value="current.rates.bills" :searchBar="false">
              <column field="dueDate" header="Due Date" bodyStyle="text-align: center" headerStyle="width: 220px" sortable>
                <template #body="slot">
                  <router-link
                    :to="{
                      path: '/billing/report/detail/current/' + account.system.id + '/' + account.id + '/' + slot.data.dueDate,
                      query: $route.query
                    }"
                  >
                    {{$formatUTCDate(slot.data.dueDate)}}
                  </router-link>
                </template>
              </column>
              <column field="description" header="Description" bodyStyle="text-align: center" headerStyle="width: 220px" sortable></column>
              <column field="totals.count.active" header="Active Count" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column header="Non billable" headerStyle="width: 110px" bodyStyle="text-align: center" sortable>
                <template #body="slot">
                  {{ (slot.data.totals.count.holding || 0) + (slot.data.totals.count.paused || 0) }}
                </template>
              </column>
              <column field="totals.count.count" header="Total Count" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>

              <column field="totals.total.active" header="Total" headerStyle="width: 200px" bodyStyle="text-align: center" sortable>
                <template #body="slot">
                  {{slot.data.totals.total.active}} {{current.currency}}
                </template>
              </column>
            </data-table>
          </div>

          <div v-if="customerSatisfaction.length > 0" class="section">
            <div class="title">Customer Satisfaction</div>
            <data-table :value="customerSatisfaction" :searchBar="false">
              <column field="expiration" header="Expiration" bodyStyle="text-align: center" headerStyle="width: 100px" sortable>
                <template #body="slot">
                  {{ slot.data.expiration ? $formatUTCDate(slot.data.expiration) : 'Never' }}
                </template>
              </column>
              <column field="name" header="Vehicle ID" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="type" header="Type" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="fleet" header="Fleet" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="activation.status" header="Status" headerStyle="width: 110px" bodyStyle="text-align: center" sortable>
                <template #body="slot">
                  <span class="badge" :class="slot.data.activation.status">
                    {{activationStatusMap[slot.data.activation.status]}}<span v-if="slot.data.activation.forced">*</span>
                  </span>
                </template>
              </column>
            </data-table>
          </div>

          <div v-if="researchAndDevelopment.length > 0" class="section">
            <div class="title">Research & Development</div>
            <data-table :value="researchAndDevelopment" :searchBar="false">
              <column field="expiration" header="Expiration" bodyStyle="text-align: center" headerStyle="width: 100px">
                <template #body="slot">
                  {{ slot.data.expiration ? $formatUTCDate(slot.data.expiration) : 'Never' }}
                </template>
              </column>
              <column field="name" header="Vehicle ID" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="type" header="Type" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="fleet" header="Fleet" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="activation.status" header="Status" headerStyle="width: 110px" bodyStyle="text-align: center" sortable>
                <template #body="slot">
                  <span class="badge" :class="slot.data.activation.status">
                    {{activationStatusMap[slot.data.activation.status]}}<span v-if="slot.data.activation.forced">*</span>
                  </span>
                </template>
              </column>
            </data-table>
          </div>

          <div v-if="pause.length > 0" class="section">
            <div class="title">In Pause</div>
            <data-table :value="pause" :searchBar="false">
              <column field="expiration" header="Expiration" bodyStyle="text-align: center" headerStyle="width: 100px" sortable>
                <template #body="slot">
                  {{ slot.data.expiration ? $formatUTCDate(slot.data.expiration) : 'Never' }}
                </template>
              </column>
              <column field="name" header="Vehicle ID" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="type" header="Type" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="fleet" header="Fleet" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="activation.status" header="Status" headerStyle="width: 110px" bodyStyle="text-align: center" sortable>
                <template #body="slot">
                  <span class="badge" :class="slot.data.activation.status">
                    {{activationStatusMap[slot.data.activation.status]}}<span v-if="slot.data.activation.forced">*</span>
                  </span>
                </template>
              </column>
            </data-table>
          </div>

          <div v-if="current.rates.notInDataPlan.length > 0" class="section">
            <div class="title">Not on Data Plan</div>
            <data-table :value="current.rates.notInDataPlan" :searchBar="false">
              <column field="name" header="Vehicle ID" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="type" header="Type" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="fleet" header="Fleet" headerStyle="width: 110px" bodyStyle="text-align: center" sortable></column>
              <column field="activation.status" header="Status" headerStyle="width: 110px" bodyStyle="text-align: center" sortable>
                <template #body="slot">
                  <span class="badge" :class="slot.data.activation.status" v-if="slot.data.activation.status !== 'none'">
                    {{activationStatusMap[slot.data.activation.status]}}<span v-if="slot.data.activation.forced">*</span>
                  </span>
                </template>
              </column>
            </data-table>
          </div>

        </div>

        <h1 v-if="error" class="no-data">This account has no data plans set</h1>
      </div>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page.vue'
import Dropdown from '@/components/Dropdown.vue'
import DataTable from '@/components/DataTable.vue'

import Column from 'primevue/column'

import gql from 'graphql-tag'

import {
  syncWorkingAccount,
  parseReportRouteQuery,
  workingAccountToReportSelection,
  REPORT_QUERY_KEYS
} from '@/lib/billing-navigation'

export default {
  name: 'BillingReportView',

  components: {
    Page,
    Dropdown,
    DataTable,
    Column
  },

  methods: {
    buildReportRouteQuery () {
      const k = REPORT_QUERY_KEYS
      const query = {
        [k.system]: String(this.account.system.id),
        [k.account]: String(this.account.id)
      }
      const name = this.account.label || this.account.name || ''
      if (name) {
        query[k.name] = name
      }
      return query
    },

    searchAccount (searchText) {
      if (searchText.length < 2) {
        return false
      }

      this.searchAccountLoading = true

      this.$apollo.query({
        query: gql`
          query ($searchText: String!) {
            platform {
              accounts: searchAccount (searchText: $searchText) {
                id
                name
                system {
                  id
                  name
                }
                value: id
                label: name
              }
            }
          }
        `,
        variables: {
          searchText
        }
      }).then(response => {
        this.searchAccountLoading = false
        this.accountList = response.data.platform.accounts
      })
    },

    getBills () {
      if (!this.account || !this.account.system || !this.account.id) {
        return
      }
      syncWorkingAccount(this.$store, {
        value: this.account.id,
        legacyAccountId: this.account.id,
        label: this.account.label || this.account.name,
        system: this.account.system
      })
      this.bills = []
      this.error = false
      this.loading = true
      this.updateReportQuery()

      this.$apollo.query({
        query: gql`
          query ($systemId: String!, $accountId: ID!) {
            billing {
              current: getCurrentBillingBill(systemId: $systemId, accountId: $accountId) {
                currency
                rates {
                  bills: normal {
                    dueDate
                    description
                    totals {
                      count {
                        active
                        holding
                        paused
                        count
                      }
                      total {
                        active
                      }
                    }
                  }
                  customerSatisfaction {
                    dueDate
                    devices {
                      id
                      name
                      type
                      fleet
                      activation {
                        status
                        forced
                      }
                    }
                  }
                  researchAndDevelopment {
                    dueDate
                    devices {
                      id
                      name
                      type
                      fleet
                      activation {
                        status
                        forced
                      }
                    }
                  }
                  pause {
                    dueDate
                    devices {
                      id
                      name
                      type
                      fleet
                      activation {
                        status
                        forced
                      }
                    }
                  }
                  notInDataPlan {
                    id
                    name
                    type
                    fleet
                    activation {
                      status
                      forced
                    }
                  }
                }
              }
            }
          }
        `,
        variables: {
          systemId: this.account.system.id,
          accountId: this.account.id
        }
      }).then(response => {
        this.current = response.data.billing.current
      }).catch(error => {
        if (error.graphQLErrors[0].extensions.code === 'BILLING_ACCOUNT_NOT_FOUND') {
          this.error = true
        }
      }).finally(() => {
        this.loading = false
      })
    },

    updateReportQuery () {
      const q = this.$route.query
      const cur = parseReportRouteQuery(this.$route)
      const name = this.account.label || this.account.name || ''
      const same =
        String(cur.systemId) === String(this.account.system.id) &&
        String(cur.accountId) === String(this.account.id) &&
        (cur.accountName || '') === (name || '')
      const legacyKeys = q.systemId != null || q.accountId != null || q.accountName != null
      if (same && !legacyKeys) {
        return
      }
      this.$router.replace({
        path: this.$route.path,
        query: this.buildReportRouteQuery()
      })
    },

    restoreReportStateFromQuery () {
      const { accountId, systemId, accountName } = parseReportRouteQuery(this.$route)

      if (accountId && systemId) {
        this.account = {
          id: accountId,
          value: accountId,
          label: accountName || `#${accountId}`,
          name: accountName || `#${accountId}`,
          system: {
            id: systemId,
            name: systemId
          }
        }
        this.getBills()
        return
      }

      const fromStore = workingAccountToReportSelection(this.$store.state.workingAccount)
      if (!fromStore) return

      this.account = fromStore
      this.getBills()
    },

    normalizeNonBillable (name) {
      const ret = []
      this.current.rates[name].forEach(item => {
        item.devices.forEach(device => {
          ret.push({
            expiration: item.dueDate,
            ...device
          })
        })
      })
      return ret
    },

    toCsvValue (value) {
      const str = value == null ? '' : String(value)
      // Escapa aspas duplicando e envolve tudo entre aspas
      return `"${str.replace(/"/g, '""')}"`
    },

    downloadCsv (rows, filename) {
      const csvContent = rows.map(row => row.map(this.toCsvValue).join(',')).join('\r\n')
      // BOM ajuda Excel a abrir UTF-8 corretamente
      const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },

    exportCSV () {
      const rows = [
        ['Due Date', 'Description', 'Active Count', 'Non billable', 'Total Count', 'Total']
      ]
      this.current.rates.bills.forEach(bill => {
        rows.push([
          new Date(bill.dueDate).toISOString().split('T')[0],
          bill.description,
          bill.totals.count.active,
          (bill.totals.count.holding || 0) + (bill.totals.count.paused || 0),
          bill.totals.count.count,
          bill.totals.total.active
        ])
      })
      this.downloadCsv(rows, `report_${this.account.name}.csv`)
    }
  },

  computed: {
    customerSatisfaction () {
      return this.normalizeNonBillable('customerSatisfaction')
    },

    researchAndDevelopment () {
      return this.normalizeNonBillable('researchAndDevelopment')
    },

    pause () {
      return this.normalizeNonBillable('pause')
    }
  },

  data () {
    return {
      account: null,
      accountList: [],
      searchAccountLoading: false,
      current: null,
      error: false,
      loading: false,
      activationStatusMap: {
        active: 'Active',
        holding: 'Installation Holding',
        replaced: 'Replaced',
        rma: 'RMA'
      }
    }
  },

  watch: {
    '$route.query': {
      handler () {
        this.restoreReportStateFromQuery()
      },
      deep: true
    }
  },

  mounted () {
    this.restoreReportStateFromQuery()
    this.$moveFocusToFirstElement()
  }
}
</script>

<style lang="less" scoped>
.no-data {
  font-size: 18pt;
  font-weight: 100;
  color: contrast(@main-color);
  margin-top: 100px;
  opacity: 0.5;
  text-align: center;
}

.result {
  margin-top: 30px;
}

.badge {
  background: fade(@success-color, 10%);
  color: @success-color;
  padding: 5px 12px;
  border-radius: 3px;
  font-weight: bold;

  &.holding {
    background: fade(@warning-color, 10%);
    color: @warning-color;
  }

  &.replaced {
    background: fade(#C5E898, 10%);
    color: #C5E898;
  }
  &.rma {
    background: fade(#4942E4, 10%);
    color: #4942E4;
  }
}

.section {
  margin-bottom: 25px;

  .title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title {
    opacity: 0.7;
  }
}
</style>
